import React, { useEffect, useState, useRef } from "react";
import "../styles/Categories.css";
import { useNavigate } from "react-router-dom";
import { Plus, ChevronLeft, ChevronRight, Trophy } from "lucide-react";
import { getBestSellers } from "../services/productService";
import { BASE_URL, IMAGE_BASE_URL } from "../api/api";


function BestSellers() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [bestSellers, setBestSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const data = await getBestSellers();
        setBestSellers(data);
      } catch (error) {
        console.error("Failed to load best sellers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBestSellers();
  }, []);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleSeeAllClick = () => {
    navigate("/view");
  };

  if (loading) return <p className="text-center my-5">🏆 Loading Best Sellers...</p>;

  return (
    <div className="container my-5 position-relative">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center gap-2">
          <Trophy color="#FD7E14" size={22} />
          <p className="mb-0 section-title">Best Sellers</p>
        </div>
        <button
          onClick={handleSeeAllClick}
          className="btn btn-link p-0 text-decoration-none text-dark seeAll-text"
          style={{ cursor: "pointer" }}
        >
          See All
        </button>
      </div>

      {/* Scroll Buttons */}
      <button
        className="scroll-btn left"
        onClick={() => handleScroll("left")}
      >
        <ChevronLeft size={20} />
      </button>
      <button
        className="scroll-btn right"
        onClick={() => handleScroll("right")}
      >
        <ChevronRight size={20} />
      </button>

      {/* Horizontal Scrollable Row */}
      <div
        ref={scrollRef}
        className="d-flex flex-nowrap overflow-auto gap-3 pb-2 scroll-container"
        style={{ scrollBehavior: "smooth" }}
      >
        {bestSellers.length === 0 ? (
          <p>No best sellers found.</p>
        ) : (
          bestSellers.map((product) => {
            const primaryImage = product.images?.find((img) => img.is_primary);
            const imageUrl = primaryImage
              ? `${IMAGE_BASE_URL}storage/${primaryImage.image_path}`
              : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="

            return (
              <div
                key={product.id}
                className="card border-0 product-card"
                style={{
                  cursor: "pointer",
                  minWidth: "200px",
                  maxWidth: "200px",
                  flex: "0 0 auto",
                }}
                onClick={() => handleProductClick(product.id)}
              >
                <div className="position-relative">
                  <img
                    src={imageUrl}
                    alt={product.name}
                    className="card-img-top"
                    style={{
                      borderRadius: "10px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />

                  {/* Add to Cart Button */}
                  <button
                    className="position-absolute d-flex justify-content-center align-items-center"
                    style={{
                      bottom: "10px",
                      right: "10px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: "#FD7E14",
                      border: "none",
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("🛒 Add to cart:", product.name);
                    }}
                  >
                    <Plus size={20} color="white" />
                  </button>
                </div>

                <div className="card-body p-2 text-center">
                  <h6 className="card-title mb-1">
                    {product.name.length > 24
                      ? product.name.substring(0, 24) + "..."
                      : product.name}
                  </h6>
                  {/* <p className="Cardprice-title text-muted mb-0">
                    Rs.{product.sale_price ?? product.price}
                  </p> */}

                  <div className="Cardprice-title mb-0">
                    {product.sale_price ? (
                      <>
                        <span className="text-muted text-decoration-line-through me-2">
                          Rs.{product.price}
                        </span>
                        <span className="text-danger fw-semibold">
                          Rs.{product.sale_price}
                        </span>
                      </>
                    ) : (
                      <span>Rs.{product.price}</span>
                    )}
                  </div>

                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default BestSellers;